import { render, staticRenderFns } from "./TemplateEdicao.vue?vue&type=template&id=700b1a74&scoped=true&"
import script from "./TemplateEdicao.vue?vue&type=script&lang=js&"
export * from "./TemplateEdicao.vue?vue&type=script&lang=js&"
import style0 from "./TemplateEdicao.vue?vue&type=style&index=0&id=700b1a74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700b1a74",
  null
  
)

export default component.exports